import styled from "styled-components";
import colors from "../../styles/colors";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 30px 0 80px 0;
    background-color: ${colors.bgColorBlack2};
    color: white;

    /* Tutte le immagini partono dall alto e non dal centro*/
    & img {
        object-position: top;
    }
`;

const LineDivider = styled.div`
    width: 90%;
    height: 1px;
    background-color: ${colors.bgColorBlack2};
    margin: 20px 0;

    &.no-margin {
        margin: 2px;
        background-color: rgba(255, 255, 255, 0.15);
    }
`;

const BoxSingleYear = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    border: 1px solid rgba(163, 27, 27, 0.35);
    border-radius: 10px;
    overflow: hidden;
    background: linear-gradient(160deg, rgba(163, 27, 27, 0.28) 0%, rgba(255, 255, 255, 0.07) 100%);
    color: white;
`;

const BoxYearsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: center;
    width: 95%;

    & .title-best-years {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        background-color: ${colors.bgColorBlack2};
        color: white;
    }
`;

const RowSingleYear = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 33.33%;
    padding: 0 10px;
`;

const LineStatsTotalMatchWin = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 80%;
    padding: 0 10px;
    margin: 10px 0;
    position: relative;
`;

const ProgressBarContainer = styled.div`
    position: relative;
    width: 100%;
    height: 20px;
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    overflow: hidden;
    margin: 0 10px;
`;

const ProgressBar = styled.div<{ percentage: number }>`
    height: 100%;
    background-color: #28a745;
    border-radius: 10px;
    transition: width 0.3s ease;
    width: ${props => props.percentage}%;
`;

const StatsText = styled.span`
    font-weight: bold;
    font-size: 14px;
    color: white;
    white-space: nowrap;
`;

const BoxMatches = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
`;

type WinState = 'win' | 'loss' | 'nc';

const WinBadge = styled.span<{ result: WinState }>`
    position: absolute;
    top: 14px;
    right: 14px;
    font-size: 11px;
    font-weight: bold;
    padding: 2px 7px;
    border-radius: 4px;
    z-index: 2;
    letter-spacing: 0.5px;
    background-color: ${props =>
        props.result === 'win' ? 'rgba(40, 167, 69, 0.9)' :
        props.result === 'nc'  ? 'rgba(255, 193, 7, 0.9)'  :
                                 'rgba(220, 53, 69, 0.9)'
    };
    color: white;
`;

const BoxSingleMatch = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px;
    width: 33.33%;
    height: 350px;
    cursor: pointer;
    transition: opacity 0.3s ease;


    & .normal-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: linear-gradient(160deg, rgba(163, 27, 27, 0.28) 0%, rgba(255, 255, 255, 0.07) 100%);
        width: 100%;
    }

    & .hover-content {
        display: none;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 95%;
        height: 90%;
        position: absolute;
        /* top: 0; */
        /* left: 0; */
        background-color: ${colors.bgColorBlack2};
        color: white;
        opacity: 0;

        & img {
            width: 150px;
            height: 180px;
            object-fit: contain;
            margin-bottom: 10px;
        }
    }

    &:hover .hover-content {
        display: flex;
        opacity: 1;
    }

    &:hover .normal-content {
        display: none;
    }
`;

const CardMatch = styled.div<{ winState?: WinState }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 93%;
    height: 95%;
    border: 1px solid ${props =>
        props.winState === 'win'  ? 'rgba(40, 167, 69, 0.55)'  :
        props.winState === 'loss' ? 'rgba(220, 53, 69, 0.55)'  :
        props.winState === 'nc'   ? 'rgba(255, 193, 7, 0.55)'  :
        'rgba(163, 27, 27, 0.25)'
    };
    border-radius: 5px;
    padding: 2px;
    background: linear-gradient(160deg, rgba(163, 27, 27, 0.28) 0%, rgba(255, 255, 255, 0.07) 100%);
    color: white;


    & .avatar-wrestler {
        width: 100px;
        max-width: 80%;
        height: 100px;
        object-fit: cover;
        border-radius: 8px;
    }

    & .belt-image {
        width: 50px;
        height: 50px;
        object-fit: contain;
        object-position: center;
    }

    & .type-match {
        margin: 5px 0;
    }

    & .ppv-name {
        text-align: center;
        width: 100%;
    }
`;

function WrestlerBestYears({ wrestlerData }: any) {
    const navigate = useNavigate();

    const getWinState = (match: any): WinState => {
        if (match.is_no_contest) return 'nc';
        return match.pivot.is_winner ? 'win' : 'loss';
    };

    const winLabel = (match: any) => {
        if (match.is_no_contest) return 'NC';
        return match.pivot.is_winner ? 'W' : 'L';
    };

    // Funzione per navigare al PPV specifico
    const navigateToPpv = (ppv: any) => {
        const ppvId = ppv.id;
        const ppvName = ppv.ppv_description.name;
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    }


    return (
        <Container>
            {/* Linea che divide i componenti */}
            {/* <LineDivider /> */}

            {/* Titolo */}
            <h1>I migliori anni</h1>

            <BoxYearsContainer>
                {/* ciclo wrestlerData.bestYears  */}
                {wrestlerData.bestYears.map((bestYear: any, key: any) => (
                    <RowSingleYear key={key}>
                        <BoxSingleYear>
                            <div className="title-best-years">
                                <h1>{bestYear.year}</h1>
                            </div>

                            {/* Questa è una linea lunga sempre fissa dove a sinistra ci sono scritti i match vinti (bestYear.wins) e all'estremità il totale dei match(bestYears.fights) 
                            A seconda della percentuale tra i due c'è una linea verde che si allunga verso la fine della linea
                            */}
                            <LineStatsTotalMatchWin>
                                <StatsText>{bestYear.wins}</StatsText>
                                    <ProgressBarContainer>
                                        <ProgressBar 
                                            percentage={bestYear.fights > 0 ? (bestYear.wins / bestYear.fights) * 100 : 0} 
                                        />
                                    </ProgressBarContainer>
                                <StatsText>{bestYear.fights}</StatsText>
                            </LineStatsTotalMatchWin>

                            {/* Lista degli incontri nell anno (bestYears.matches)  */}
                            <BoxMatches>
                                {bestYear.matches.map((match: any, key: any) => (

                                    <BoxSingleMatch onClick={() => navigateToPpv(match.ppv)} className="box-single-match" key={key}>
                                        <WinBadge result={getWinState(match)}>{winLabel(match)}</WinBadge>
                                        {/* Se il match ha type_match.type uguale a single  */}
                                        {match.type_match.type === "single" && (
                                            <>
                                                {/* Faccio vedere avversario (per vedere avversario ciclo wrestlers dentro
                                                match e se id è diverso da wretslerdata.id faccio vedeere l avatar) */}
                                                {match.wrestlers.map((wrestler: any, key: any) =>
                                                    wrestler.id !== wrestlerData.id && (
                                                        <CardMatch winState={getWinState(match)} className="card-match-single normal-content" key={key}>
                                                            <img className="avatar-wrestler" src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                                                            <h6>vs {wrestler.name}</h6>
                                                            <LineDivider className="no-margin"/>
                                                            <h6 className="type-match fst-italic">{match.type_match.name}</h6>
                                                            {/* Se match.belt non è null, faccio vedere l immagine del titolo */}
                                                            {match.belt && (
                                                                <div className="text-center p-0 m-0">
                                                                    <img className="belt-image" src={process.env.REACT_APP_STORAGE_URL + match.belt.img_path} alt={match.belt.name} />
                                                                    <h6>{match.belt.name}</h6>
                                                                </div>
                                                            )}
                                                            <h6 className="text-uppercase ppv-name">{match.ppv.ppv_description.name}</h6>
                                                        </CardMatch>
                                                    )
                                                )}
                                            </>
                                        )}
                                        {/* altrimenti in tutti gli altri casi  */}
                                        {match.type_match.type !== "single" && (
                                            <CardMatch winState={getWinState(match)} className="card-match-other normal-content" key={key}>
                                                <img className="avatar-wrestler" src={process.env.REACT_APP_STORAGE_URL + match.ppv.img_path} alt={match.ppv.name} />
                                                {/* type deve avere prima lettera maiuscola */}
                                                <h6>{match.type_match.type.charAt(0).toUpperCase() + match.type_match.type.slice(1)}</h6>
                                                <LineDivider className="no-margin"/>
                                                <h6 className="type-match fst-italic">{match.type_match.name}</h6>
                                                <h6 className="text-uppercase ppv-name">{match.ppv.ppv_description.name}</h6>
                                            </CardMatch>
                                        )}

                                        {/* Contenuto hover */}
                                        <CardMatch className="hover-content">
                                            <img className="avatar-wrestler" src={process.env.REACT_APP_STORAGE_URL + match.ppv.img_path} alt={match.ppv.name} />
                                            <h6>{match.type_match.type.charAt(0).toUpperCase() + match.type_match.type.slice(1)}</h6>
                                            <h6 className="text-uppercase ppv-name">{match.ppv.ppv_description.name}</h6>
                                        </CardMatch>

                                    </BoxSingleMatch>

                                ))}
                            </BoxMatches>
                        </BoxSingleYear>
                    </RowSingleYear>
                ))}
            </BoxYearsContainer>
        </Container>
    )
}

export default WrestlerBestYears;